import absTheme from './abs';
import apprizeTheme from './apprize';
import gustoTheme from './gusto';
import helixTheme from './helix';
import nationwideTheme from './nationwide';
import proficientTheme from './proficient';
import ripplingTheme from './rippling';
import rmrTheme from './rmr';
import { WhiteLabelTheme } from './types';

const QUERY_KEY = 'whiteLabeling';

const DEFAULT_IOS_APP_STORE_LINK = 'https://apps.apple.com/us/app/elevate-my-benefits/id1626068256';
const DEFAULT_ANDROID_APP_STORE_LINK =
  'https://play.google.com/store/apps/details?id=com.elevateaccounts.mobile';

const DEFAULT_IOS_APP_LINK = 'elevate://open-app';
const DEFAULT_ANDROID_APP_LINK = 'elevate://open-app';

export const THEMES = {
  apprize: 'apprize',
  rippling: 'rippling',
  proficient: 'proficient',
  rmr: 'rmr',
  gusto: 'gusto',
  abs: 'abs',
  helix: 'helix',
  nationwide: 'nationwide',
};

const TRUE_KEY = 'true;';
const { search } = window.location;
const envVariable = import.meta.env.REACT_APP_WHITE_LABEL;
let query = new URLSearchParams(search).get(QUERY_KEY);

export const isThemeApplied = (key: string) => {
  return query === key || envVariable === key || sessionStorage.getItem(key);
};

const getTheme = () => {
  let currentTheme: WhiteLabelTheme | null = null;
  if (isThemeApplied(THEMES.apprize)) {
    currentTheme = apprizeTheme;
  }
  if (isThemeApplied(THEMES.rippling)) {
    currentTheme = ripplingTheme;
  }

  if (isThemeApplied(THEMES.gusto)) {
    currentTheme = gustoTheme;
    sessionStorage.setItem(THEMES.gusto, TRUE_KEY);
  }

  if (isThemeApplied(THEMES.rmr)) {
    currentTheme = rmrTheme;
    sessionStorage.setItem(THEMES.rmr, TRUE_KEY);
  }
  if (isThemeApplied(THEMES.abs)) {
    currentTheme = absTheme;
    sessionStorage.setItem(THEMES.abs, TRUE_KEY);
  }
  if (isThemeApplied(THEMES.helix)) {
    currentTheme = helixTheme;
    sessionStorage.setItem(THEMES.helix, TRUE_KEY);
  }

  if (isThemeApplied(THEMES.proficient)) {
    currentTheme = proficientTheme;
    sessionStorage.setItem(THEMES.proficient, TRUE_KEY);
  }

  if (isThemeApplied(THEMES.nationwide)) {
    currentTheme = nationwideTheme;
    sessionStorage.setItem(THEMES.nationwide, TRUE_KEY);
    query = THEMES.nationwide;
  }
  if (!currentTheme) {
    return {
      IOSAppStoreLink: DEFAULT_IOS_APP_STORE_LINK,
      androidAppStoreLink: DEFAULT_ANDROID_APP_STORE_LINK,

      IOSAppLink: DEFAULT_IOS_APP_LINK,
      androidAppLink: DEFAULT_ANDROID_APP_LINK,
    } as WhiteLabelTheme;
  }

  if (currentTheme.title) {
    document.title = currentTheme.title;
  }

  return {
    key: envVariable || query,
    partnerTitle: currentTheme.title,
    title: currentTheme.title?.toLowerCase(),
    termsAndConditions: currentTheme?.termsAndConditions,

    IOSAppStoreLink: currentTheme.IOSAppStoreLink || DEFAULT_IOS_APP_STORE_LINK,
    androidAppStoreLink: currentTheme.androidAppStoreLink || DEFAULT_ANDROID_APP_STORE_LINK,
    loginIconHeight: currentTheme.loginIconHeight,
    loginIconWidth: currentTheme.loginIconWidth,
    isSidebarItemWide: currentTheme.isSidebarItemWide,
    isLoginFooter: currentTheme.isLoginFooter,
    IOSAppLink: currentTheme.IOSAppLink || DEFAULT_IOS_APP_LINK,
    androidAppLink: currentTheme.androidAppLink || DEFAULT_ANDROID_APP_LINK,
    mobileAppIconWidth: currentTheme?.mobileAppIconWidth || 35,
    mobileAppIconHeight: currentTheme?.mobileAppIconHeight || 35,
    mobileAppIcon: currentTheme.mobileAppIcon,
    mobileAppTitle: currentTheme.mobileAppTitle,

    privacyPolicy: currentTheme?.privacyPolicy,
    loginScreenTitle: currentTheme?.loginScreenTitle,
    tetriaryAccentButton: currentTheme.tetriaryAccentButton, // custom field
    colors: currentTheme.colors || {},
    fonts: currentTheme?.fonts || {},
    logo: currentTheme.logo,
    minifyLogo: currentTheme.minifyLogo,
    images: currentTheme.images || {},
    font: currentTheme.font || "'Inter', sans-serif", // Alse you need add font import to global.scss example: @import url('https://fonts.googleapis.com/css2?family=PT+Serif:ital,wght@0,400;0,700;1,400;1,700&display=swap');
    titleFont: currentTheme.titleFont,
    rounds: currentTheme.rounds || {},
    favicon: currentTheme.favicon || '', // Save this icon, for example 'fidelityFavicon.ico', in public folder, here put the path to this icon file.
    favicon16: currentTheme.favicon16 || '', // Save this icon, for example 'favicon-fidelity-16x16.png', in public folder, here put the path to this icon file.
    favicon32: currentTheme.favicon32 || '', // Save this icon, for example 'favicon-fidelity-32x32.png', in public folder, here put the path to this icon file.
    faviconAppleTouch: currentTheme.faviconAppleTouch || '', // Save this icon, for example 'apple-touch-icon-fidelity.png', in public folder, here put the path to this icon file.
    shadows: currentTheme.shadows || {},
  } as WhiteLabelTheme;
};

export default getTheme();
